// extracted by mini-css-extract-plugin
export default {"time":"time_time__eIXpL","date":"time_date__tglQb","time_value":"time_time_value__xkNDT"};